import { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import { useLocation } from 'react-router';

dayjs.extend(isBetween);
dayjs.extend(utc);

export const EVENT_NAME_HOLIDAY = 'Valentine';

const eventDates = {
  startDate: dayjs('2026-04-24 00:00:00.000+00:00'),
  endDate: dayjs('2026-05-04 23:59:59.000+00:00')
};

const eventPigeonDates = {
  startDate: dayjs('2026-04-24 00:00:00.000+00:00'),
  endDate: dayjs('2026-04-26 23:59:59.000+00:00')
};

const eventPigeonDatesSecond = {
  startDate: dayjs('2026-04-28 00:00:00.000+00:00'),
  endDate: dayjs('2026-05-03 23:59:59.000+00:00')
};

const eventWheelDates = {
  startDate: dayjs('2026-04-24 00:00:00.000+00:00'),
  endDate: dayjs('2026-05-03 23:59:59.000+00:00')
};

export const eventDatesLuckyCard = {
  startDate: dayjs('2026-04-07 00:00:00.000+00:00'),
  endDate: dayjs('2026-04-13 23:59:59.000+00:00')
};

export const eventHolidayDates = {
  startDate: dayjs('2026-02-09 00:00:00.000+00:00'),
  endDate: dayjs('2026-02-16 23:59:59.000+00:00')
};

const isEventActiveDates = (startDate: dayjs.Dayjs, endDate: dayjs.Dayjs) => {
  const currentDate = dayjs().format();
  return dayjs(currentDate).utc().isBetween(startDate, endDate, 'minute', '[]');
};

// добавляем сюда название event и по ключу дальше в коде обращаемся к нужному event (например eventActive.holiday)
const getActiveEvents = () => {
  return {
    eventDays: isEventActiveDates(eventDates.startDate, eventDates.endDate),
    eventPigeon: isEventActiveDates(eventPigeonDates.startDate, eventPigeonDates.endDate),
    eventPigeonSecond: isEventActiveDates(
      eventPigeonDatesSecond.startDate,
      eventPigeonDatesSecond.endDate
    ),
    eventWheel: isEventActiveDates(eventWheelDates.startDate, eventWheelDates.endDate)
  };
};

const EventContext = createContext({
  eventActive: getActiveEvents(),
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  revalidate: () => {}
});

export const PromoEventContext: FC<PropsWithChildren> = ({ children }) => {
  const [eventActive, setEventActive] = useState(getActiveEvents());

  const revalidate = () => {
    const currentEvents = getActiveEvents();
    if (currentEvents.eventDays !== eventActive.eventDays) {
      setEventActive(currentEvents);
    }
  };

  return (
    <EventContext.Provider
      value={{
        eventActive,
        revalidate
      }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEvent = () => {
  return useContext(EventContext);
};

export const useRevalidateEventOnRouteChange = () => {
  const { pathname } = useLocation();
  const { revalidate } = useContext(EventContext);

  useEffect(() => {
    revalidate();
  }, [pathname]);
};
